define('product-purchase-modal/product-purchase-modal',['require','exports','module','knockout','plugins/dialog','react-product-purchase','i18next','dialog-helper/responsive','mixpanel-helper','web-urls','api-access','tealium-utils','knockout-bind-react'],function (require, exports, module) {
    var ko = require('knockout');
    var dialog = require('plugins/dialog');
    var ReactProductPurchase = require('react-product-purchase');
    var i18n = require('i18next');
    var responsiveDialog = require('dialog-helper/responsive');
    var mixpanelHelper = require('mixpanel-helper');
    var webUrls = require('web-urls');
    var apiAccess = require('api-access');
    var tealiumUtils = require('tealium-utils');

    require('knockout-bind-react');

    var ProductPurchaseModal = function (settings) {
        var self = this;
        var options = settings || {};
        var CATALOG_KEY = 50;

        var overrideProps = options.props || {};

        self.bundles = ko.observable([]);

        self.reactOptions = ko.computed(function () {
            var props = Object.assign({
                language: i18n.lng(),
                commerceUrl: webUrls.get('buyUpgradeUrl'),
                catalogKey: CATALOG_KEY,
                bundles: ReactProductPurchase.configure.configureG2MBundles(self.bundles()),

                close: function () {
                    dialog.close(self);
                    self.trackIPPData('myMeetings.html');
                    if (options.onClose) {
                        options.onClose();
                    }
                },

                track: self.trackIPPData
            }, overrideProps);

            return {
                component: ReactProductPurchase.default,
                props: props
            };
        });

        self.activate = function () {
            return apiAccess.commerce.getCatalog(CATALOG_KEY)
                .then(function (catalog) {
                    self.bundles(catalog.bundles);
                });
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);
        };

        self.trackIPPData = function (message, mixpanelData) {
            self.trackIPPTealium(message);
            self.trackIPPMixpanel(message, mixpanelData);
        };

        self.trackIPPTealium = function (message) {
            var tealiumEventList = ['plan-selection', 'plan-form', 'myMeetings.html'];

            if (tealiumEventList.indexOf(message) > -1) {
                tealiumUtils.sendTealiumEvent('meetings', message);
            }
        };

        self.trackIPPMixpanel = function (message, mixpanelData) {
            var mixpanelEventMapping = {
                'plan-form': 'IPP: Plan Form Page Shown',
                'IPP: "Checkout" clicked': 'IPP: "Checkout" clicked',
                'Marvel expiring trial: Subscribe': 'Marvel expiring trial: Subscribe',
                'Expired trial modal: Subscribe': 'Expired trial modal: Subscribe'
            };

            if (mixpanelEventMapping[message]) {
                mixpanelHelper.track(mixpanelEventMapping[message], mixpanelData);
            }
        };
    };

    ProductPurchaseModal.show = function (options) {
        return dialog.show(new ProductPurchaseModal(options));
    };

    module.exports = ProductPurchaseModal;
});

